var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"nav-link col-3",attrs:{"active-class":"active","to":{ name: 'tiersQualifications'},"href":"#"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('qualification.qualifications')))])]),_c('ShutterPanel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }